"use client";

import React, { useMemo } from "react";
import CountryPhonePrompt from "./CountryPhonePrompt";
import { useLanguage } from "@/contexts/LanguageContext";
import { getStrings } from "@/i18n/dictionaries";

/**
 * Component to display when user tries Rwanda MoMo with non-Rwandan phone
 * This is a wrapper around CountryPhonePrompt with Rwanda-specific configuration
 */
export default function RwandaPhonePrompt({
  onClose,
  onSwitchToStripe,
  detectedPhone,
  authPhone,
  profilePhone,
  profileCountry,
  selectedPaymentCountry,
}) {
  const { locale } = useLanguage();
  const t = useMemo(() => getStrings(locale, "payment"), [locale]);
  const rwandaConfig = {
    title: t.rwanda_phone_title,
    requiredPrefix: "+250",
    requiredCountryName: "Rwanda",
  };

  return (
    <CountryPhonePrompt
      onClose={onClose}
      onSwitchToStripe={onSwitchToStripe}
      onSwitchToBankTransfer={null}
      detectedPhone={detectedPhone}
      authPhone={authPhone}
      profilePhone={profilePhone}
      profileCountry={profileCountry}
      selectedPaymentCountry={selectedPaymentCountry}
      config={rwandaConfig}
    />
  );
}
